// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"dd0bc5b6c9173c0cbb97","691":"6256939ce1d9ae4a7d85"}[chunkId] + ".js";
};